/* @-- - Store usando os middlewares do redux-saga (w/monitor), redux-thunk e redux-devtools-extension - https://github.com/reduxjs/redux-devtools */
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension'
import RootReducers from 'reducers'
import RootSagas from 'sagas'
import thunk from 'redux-thunk'
import createSagaMonitor from 'sagas/monitor'

const sagaMiddleware = process.env.REACT_APP_CONTENT_PROTECT === 'false' ? createSagaMiddleware({ sagaMonitor: createSagaMonitor() }) : createSagaMiddleware()
const middleware = [thunk, sagaMiddleware]
const composeEnhancers = composeWithDevTools({})
const store = createStore(RootReducers, composeEnhancers(
  applyMiddleware(...middleware),
))
if(process.env.REACT_APP_CONTENT_PROTECT === 'false'){
  store.subscribe(() => {
    console.log('%c Dados da store', 'font-size: 10px; color:#F0B323; font-weight: bold', store.getState())
  })
}
sagaMiddleware.run(RootSagas)
const initStore = (preloadedState={}) => store
export type AppDispatch = ReturnType<typeof initStore>['dispatch']
export type AppStore = ReturnType<typeof initStore>
export default store

/* @-- - Store usando os middlewares do redux-saga e redux-thunk juntos, sem o redux-devtools-extension
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import RootReducers from 'reducers'
import RootSagas from 'sagas'
import thunk from 'redux-thunk'
const sagaMiddleware = createSagaMiddleware()
const middleware = [thunk, sagaMiddleware]
const store = createStore(RootReducers,
  applyMiddleware(...middleware),
)
sagaMiddleware.run(RootSagas)
export default store
*/

/* @-- - Store usando o middleware do redux-saga 
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import RootReducers from 'reducers'
import RootSagas from 'sagas'
const sagaMiddleware = createSagaMiddleware()
const store = createStore(
    RootReducers,
    applyMiddleware(sagaMiddleware)
)
sagaMiddleware.run(RootSagas)
export default store
*/

/*  @-- - Store usando o middleware do redux-trunk junto com redux-devtools-extension
    @REF: https://github.com/reduxjs/redux-devtools
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import RootReducers from 'reducers'
import thunk from 'redux-thunk'
const middleware = [thunk]
const composeEnhancers = composeWithDevTools({})
const store = createStore(RootReducers, composeEnhancers(
  applyMiddleware(...middleware),
))
export default store
*/

/* @-- - Store com redux, configuração simples 
import { createStore } from 'redux'
import RootReducers from 'reducers'
const store = createStore(RootReducers)
export default store
*/

/* @-- - Store mais atual usando o configureStore da ultima versão do redux
import RootReducers from 'reducers'
import { configureStore } from '@reduxjs/toolkit'
const store = configureStore(
    { reducer: RootReducers }
)
export default store
*/